<template>
    <div class="horizontal-menu">
        <ul>
            <li><strong>产品中心</strong></li>
            <router-link tag="li" :to="{name: 'product-category'}" v-bind:class="{ selected: active == 0 }">产品列表</router-link>
            <router-link tag="li" :to="{name: 'solution'}" v-bind:class="{ selected: active == 1 }">解决方案</router-link>
            <router-link tag="li" :to="{name: 'product-consult'}" v-bind:class="{ selected: active == 2 }">在线咨询</router-link>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SubNav",
        props: ['active']
    }
</script>

<style scoped lang="stylus">
    .horizontal-menu
        width 100%
        background-color #F5F5F5
        height 52px
        ul
            list-style none
            margin 0 auto
            width 1000px
            li
                float left
                font-size 13px
                padding 14px 20px
                margin 0 10px
                cursor pointer
                strong
                    font-size 15px
                    cursor default

        .selected
            background-color #E9E9E9
            color #EE1234
            border-bottom 3px solid #EE1234
</style>